//import { useOktaAuth } from "@okta/okta-react";
//import axios from "axios";

//some helper methods to provide some common functionality related to react query usage scenarios

import { useQueryClient } from "@tanstack/react-query";

export function useReactQueryHelpers() {
  //const { oktaAuth } = useOktaAuth();

  const queryClient = useQueryClient();

  // async function getQueryData(queryKey, queryFn, enabledCallback) {
  //   return useQuery({
  //     queryKey: queryKey,
  //     queryFn: async () => await queryFn(),
  //     enabled: enabledCallback,
  //   });
  // }

  //this should force a requery of the data
  function invalidateReactQueryKey(key) {
    queryClient.invalidateQueries(key);
  }

  //this should force a requery of the data in the background
  function makeReactQueryKeyStale(key) {
    queryClient.invalidateQueries(key, {
      refetchActive: true,
      refetchInactive: true,
    });
  }

  // export the exposed methods
  return {
    invalidateReactQueryKey,
    makeReactQueryKeyStale,
  };
}
